export interface U3141UseReconstituteChainFromPdfHandlersParams {
  doReconstituteChainFromPdfFn: (
    masterLotChainId: string,
    file: File
  ) => Promise<{ data: { id?: string; status?: string } }>;
  onSuccess?: (jobId: string) => void;
  onError?: (errors: { error: unknown }) => void;
}

export interface U3141UseReconstituteChainFromPdfHandlersReturn {
  reconstituteChainFromPdf: (masterLotChainId: string, file: File) => Promise<void>;
}

export function useU3141UseReconstituteChainFromPdfHandlers({
  doReconstituteChainFromPdfFn,
  onSuccess,
  onError,
}: U3141UseReconstituteChainFromPdfHandlersParams): U3141UseReconstituteChainFromPdfHandlersReturn {
  const reconstituteChainFromPdf = async (masterLotChainId: string, file: File) => {
    try {
      const response = await doReconstituteChainFromPdfFn(masterLotChainId, file);
      const data = response?.data as Record<string, unknown> | undefined;
      const result = (data?.result ?? data?.data) as Record<string, unknown> | undefined;
      const rawId = data?.id ?? result?.id;
      const jobId = typeof rawId === 'string' ? rawId : '';

      onSuccess?.(jobId);
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { reconstituteChainFromPdf };
}
